// components/PrivateRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isSuperuser = useSelector((state) => state.auth.isSuperuser);

  if (!isAuthenticated) return <Navigate to="/" />;
  if (isSuperuser) return <Navigate to="/superadmin" />;
  return children;
};

export default PrivateRoute;
